import type { ReactNode } from 'react';
import { EmptyIcon } from '@phosphor-icons/react';

type EmptyStateProps = {
  headText: string;
  subText?: string;
  /**
   * Optional custom content rendered below the texts (e.g. an icon plus a
   * call-to-action). When omitted, a neutral empty icon is shown.
   */
  children?: ReactNode;
};

export const EmptyState = ({ headText, subText, children }: EmptyStateProps) => {
  return (
    <div className="flex flex-col items-center justify-center space-y-2 p-4">
      <h2 className="text-center text-2xl font-bold">{headText}</h2>
      {subText && <p className="text-center">{subText}</p>}
      {children ?? <EmptyIcon className="size-12 text-muted-foreground" />}
    </div>
  );
};
